import { NewElementDndContext } from "@/lib/context";
import { useState } from "react";

export const NewElementDndProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [elementName, setElementName] = useState("");

  return (
    <NewElementDndContext.Provider value={{ elementName, setElementName }}>
      {children}
    </NewElementDndContext.Provider>
  );
};
